import ComposerPage from '../../components/composer/ComposerPage';

export default ComposerPage;

export { getServerSideProps } from '../../lib/backend/composer/serverPage';
